import { render, staticRenderFns } from "./faqsDetails.vue?vue&type=template&id=6db76787"
import script from "./faqsDetails.vue?vue&type=script&lang=js"
export * from "./faqsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports